import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import { useCommentsRoot } from '../Root';

const Sort = dynamic(() => import('./Sort'));
const SubscriptionSwitch = dynamic(() => import('../SubscriptionSwitch'));

const Header = ({
  children = null,
  className,
  emptyListComponent: EmptyListComponent = null,
  isSortActive = true,
  isSubscriptionAllowed = false,
  isSubscribed = false,
  onSubscribe,
}) => {
  const { isCommentsListEmpty } = useCommentsRoot();

  return (
    <>
      <div
        className={twJoin(
          'flex items-end justify-between md:items-center',
          className
        )}
      >
        <div className="flex flex-col justify-start gap-x-4 lg:flex-row">
          {isSortActive && <Sort />}
        </div>
        {isSubscriptionAllowed && (
          <SubscriptionSwitch
            isSubscribed={isSubscribed}
            onSubscribe={onSubscribe}
          />
        )}
      </div>
      {children}
      {isCommentsListEmpty && EmptyListComponent && <EmptyListComponent />}
    </>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  emptyListComponent: PropTypes.shape(),
  isSortActive: PropTypes.bool,
  isSubscriptionAllowed: PropTypes.bool,
  isSubscribed: PropTypes.bool,
  onSubscribe: PropTypes.func,
};

export default Header;
